<template>
  <div class="check-item">
    <div class="row">
      <div class="col-sm-7">{{ i18n.browser }}</div>
      <div class="col-sm-3">{{ result.text }}</div>
      <div class="col-sm-2">
        <checker-status :result="result.value"></checker-status>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
      </div>
    </div>
  </div>
</template>

<script>
import UAParser from 'ua-parser-js'
import CheckerStatus from './CheckerStatus'

const checkerName = 'web-browser'

export default {
  name: checkerName,
  data () {
    return {
      status: 'in-progress',
      result: {
        value: '',
        text: ''
      },
      i18n: window.SYSTEM_CHECK.i18n
    }
  },
  components: {
    CheckerStatus
  },
  created () {
    this.$emit('initialized', {name: checkerName})
  },
  mounted () {
    var ua = new UAParser().getResult()
    var browser = ua.browser
    var device = ua.device
    var browserMajorVersion = parseInt(browser.major)
    var os = ua.os
    var passed = false
    if (os.name === 'Windows') {
      if ((browser.name === 'IE' && browserMajorVersion >= 9) ||
          (browser.name === 'Chrome' && browserMajorVersion >= 26) ||
          (browser.name === 'Firefox' && browserMajorVersion > 3)) {
        passed = true
      }
    } else if (os.name === 'Mac OS') {
      if ((browser.name === 'Safari' && browserMajorVersion >= 5) ||
          (browser.name === 'Chrome' && browserMajorVersion >= 26) ||
          (browser.name === 'Firefox' && browserMajorVersion > 3)) {
        passed = true
      }
    } else if (os.name === 'Android') {
      if (browser.name === 'Chrome' && browserMajorVersion >= 26) {
        passed = true
      }
    } else {
      if (device.vendor === 'Apple' && (device.model === 'iPad' || device.model === 'iPhone')) {
        passed = browser.name === 'Mobile Safari'
      }
    }

    this.result.text = browser.name + ' ' + browser.version
    this.result.value = passed ? 'passed' : 'failed'
    this.$emit('completed', {name: checkerName, result: this.result.text})
  }
}
</script>
